// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import router from "./router";
import store from "./store";
import * as echarts from "echarts";
import "./directive/index.js";
import Plugin from "v-fit-columns";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import "element-ui/lib/theme-chalk/base.css";
Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        inline: true,
        button: true,
        navbar: false,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: "data-source"
    }
});

Vue.prototype.echarts = echarts;
Vue.use(Plugin);

Vue.use(ElementUI);
Vue.config.productionTip = false;

// 超时时间
axios.defaults.timeout = 10000;
// 默认地址
axios.defaults.baseURL = config.api_url;
// 是否允许跨域
// axios.defaults.withCredentials = true;

// axios.defaults.headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8";
router.beforeEach((to, form, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.meta.icon) {
        document
            .getElementsByTagName("link")[0]
            .setAttribute("href", to.meta.icon);
    }
    next();
});

Vue.prototype.axios = axios;
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    beforeCreate() {
        Vue.prototype.$tranSmit = this;
    },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js